import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { TRANSITION_TIMEOUT_MILLIS } from '../constants';
import * as S from './styles';
import { SwitchStatusLabelProps } from './types';

const SwitchStatusLabel: React.FC<SwitchStatusLabelProps> = ({
  className,
  isSelected,
  labelType,
}) => {
  const ref = useRef<HTMLSpanElement>(null);

  return (
    // the label fades in an out based on whether or not its selected.  this isn't
    // a complicated transition, but the label should not initially transition on
    // mount.  For example, when the component mounts in the "selected" state, the
    // "selected" label shouldn't fade in - it should just appear.  react-transition-group
    // is used only because it handles this initial state out of the box
    <Transition
      in={labelType === 'selected' ? isSelected : !isSelected}
      nodeRef={ref}
      timeout={TRANSITION_TIMEOUT_MILLIS}
    >
      {(status) => (
        <S.Label
          className={className}
          $isSelected={isSelected}
          $labelType={labelType}
          $status={status}
          ref={ref}
        >
          {labelType === 'selected' ? 'on' : 'off'}
        </S.Label>
      )}
    </Transition>
  );
};

export default SwitchStatusLabel;
